import { gql } from '@apollo/client';

export const GET_WEARABLES = gql`
  query GetWearables($sort: SortOrderInput, $where: WearableWhereInput) {
    getWearables(sort: $sort, where: $where) {
      id
      intID
      name
      description
      type
      platformPosition
      cdnSVG
      trim
      animationsToHide {
        id
      }
      animations {
        id
        bodyPosition
        type
        position
        cdnURL
        layer
        wearableId
      }
    }
  }
`;

export const GET_WEARABLES_WITHOUT_TRIM = gql`
  query GetWearablesWithoutTrim(
    $sort: SortOrderInput
    $where: WearableWhereInput
  ) {
    getWearables(sort: $sort, where: $where) {
      id
      intID
      name
      description
      type
      platformPosition
      cdnSVG
      animationsToHide {
        id
      }
      animations {
        id
        bodyPosition
        type
        position
        cdnURL
        layer
        wearableId
      }
    }
  }
`;
